import { SortType } from "../SortType";

export interface VendorsPOReportFilters {
  search: string | null;
  sortBy: string;
  sortType: SortType;
}

export interface VendorsPOReportSelectedFilters {
  search: string | null;
  sortBy: string;
  sortType: SortType;
}

export interface VendorsPOReportAPIFilters {
  sortBy?: string;
  sortType?: "ASC" | "DESC";
  search?: string;
}

export function parseQueryParamsForVendorsPOReportFilters(
  params: VendorsPOReportFilters | null,
  searchParams: URLSearchParams,
): VendorsPOReportFilters {
  return {
    search: searchParams.get("search") ?? params?.search ?? "",
    sortBy: searchParams.get("sortBy") ?? params?.sortBy ?? "created_date",
    sortType:
      searchParams.get("sortType") === "ASC"
        ? SortType.ASC
        : searchParams.get("sortType") === "DESC"
          ? SortType.DESC
          : (params?.sortType ?? SortType.DESC),
  };
}
